import React from "react";

import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import VideoPlayer from "./details/VideoPlayer";

import ShareThumb from "../styles/thumbnails/share-thumb.svg";

const Demo = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F8F8F8",
        display: "flex",
        paddingTop: 4,
        paddingBottom: 4,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        "& > .scrollable": {
          maxWidth: "calc(100vw - (2 * var(--table-gutter-width)))",
          maxHeight: "calc(100vh - var(--main-header-height) - var(--footer-height))",
          overflow: "auto",
          position: "relative",
          paddingLeft: "var(--table-gutter-width)",
          paddingRight: "var(--table-gutter-width)",
        },
      }}
    >
      <div className="scrollable">
        <Box
          sx={{
            marginLeft: "15px",
            textAlign: "left",
            flexDirection: "column",
            fontSize: "20px",
            fontWeight: "bold",
            "& > h6": {
              fontSize: "32px",
            },
          }}
        >
          <Typography variant="h6" color="primary">
            Ready to see the Evidence Compendium?
          </Typography>
          <p style={{ fontSize: "24px", margin: 0 }}>Watch the brief demo below</p>
          <p style={{ fontSize: "16px", margin: "5px", fontWeight: "normal" }}>
            More features coming soon. Stay tuned!
          </p>
        </Box>
        <Box sx={{ textAlign: "left", display: "flex" }}>
          <div>
            <VideoPlayer video={{ id: "_bIAG1Xb0jI", title: "" }} width={640} height={360} />
          </div>
          <Card sx={{ margin: "15px 0px 25px 15px" }}>
            <Box sx={{ width: "275px" }}>
              <Box
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                  padding: "10px",
                  "& > p": {
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: theme.palette.common.white,
                    textAlign: "center",
                    margin: "16px 25px 16px 25px",
                  },
                })}
              >
                <p>Sharing this product with your team?</p>
              </Box>
              <Box
                sx={{
                  padding: "10px",
                  textAlign: "center",
                  "& > p": {
                    fontSize: "14px",
                    fontWeight: "normal",
                    textAlign: "center",
                    padding: "0px 10px",
                    margin: "0",
                  },
                  "& > a": {
                    display: "block",
                    fontSize: "12px",
                    padding: "5px 0px 5px 0px",
                  },
                }}
              >
                <p>Tell them all about it with this summary</p>
                <a href="/ICER Analytics_Two-Pager.pdf">DOWNLOAD</a>
                <img src={ShareThumb} alt="Demo PDF" />
              </Box>
            </Box>
          </Card>
        </Box>
      </div>
    </Box>
  );
};

export default Demo;
